import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import {
  isAdvancedVerificationIncomplete,
  isResetTimePending,
  shouldApplyIosExtremeBindGate,
} from 'src/utils/iosIcloudBindStatus'

/**
 * Extreme 功能页门控（仅 iOS-Cloud 有基础/高级绑定）
 *
 * - 未绑定高级：跳转 /ios/extreme-verification
 * - 已绑未购：出升级弹窗
 * - resetTime 未就绪：gatePending
 */
export function useExtremeFeatureAccessGate(hasExtremePlan) {
  const router = useRouter()
  const resetTime = useSelector(state => state.Common.resetTime)
  const currentMode = useSelector(state => state.Common.currentMode)
  const deviceSwitchRevision = useSelector(state => state.Common.deviceSwitchRevision)
  const isIos = shouldApplyIosExtremeBindGate(currentMode)

  const resetTimePending = isIos && isResetTimePending(resetTime)
  const advancedNotBound = isIos && isAdvancedVerificationIncomplete(resetTime)
  const extremePlan = hasExtremePlan === true || hasExtremePlan === 'true'

  const gatePending = resetTimePending
  const needsExtremeBindPage = isIos && !gatePending && advancedNotBound
  const showUpgradeModal = isIos && !gatePending && !advancedNotBound && !extremePlan

  useEffect(() => {
    if (!needsExtremeBindPage) return
    if (router.pathname === '/ios/extreme-verification') return
    router.replace('/ios/extreme-verification')
  }, [needsExtremeBindPage, router, deviceSwitchRevision])

  return {
    resetTimePending,
    gatePending,
    advancedNotOver: advancedNotBound,
    needsExtremeBindPage,
    showUpgradeModal,
  }
}
